var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.99998H3C2.46957 3.99998 1.96086 4.21069 1.58579 4.58577C1.21071 4.96084 1 5.46955 1 5.99998V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H14C14.5304 19 15.0391 18.7893 15.4142 18.4142C15.7893 18.0391 16 17.5304 16 17V12M14.586 2.58598C14.7705 2.39496 14.9912 2.24259 15.2352 2.13778C15.4792 2.03296 15.7416 1.97779 16.0072 1.97548C16.2728 1.97317 16.5361 2.02377 16.7819 2.12434C17.0277 2.2249 17.251 2.3734 17.4388 2.56119C17.6266 2.74897 17.7751 2.97228 17.8756 3.21807C17.9762 3.46386 18.0268 3.72722 18.0245 3.99278C18.0222 4.25834 17.967 4.52078 17.8622 4.76479C17.7574 5.0088 17.605 5.22949 17.414 5.41398L8.828 14H6V11.172L14.586 2.58598Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.f4434c433c1e6b479d7c09305881389c.svg";
export { ForwardRef as ReactComponent };